module.exports = __webpack_public_path__ + "media/images/temp/ribbon-11-8c119fba0868333a1e4e2f4f9406d59a.png";